import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { MatListModule } from "@angular/material/list";
import { UserNavigationMenuItem } from "../../navigation/navigation-menu.models";

@Component({
    selector: "app-primary-navigation-menu",
    templateUrl: "./primary-navigation-menu.component.html",
    standalone: true,
    imports: [FontAwesomeModule, MatListModule, RouterLink, RouterLinkActive],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrimaryNavigationMenuComponent {
    readonly items = input.required<readonly UserNavigationMenuItem[]>();
    readonly itemActivated = output<void>();
}
